module.exports = __webpack_public_path__ + "static/furniture-store-mobile-plp-6fdcf9934017e78e332cbfbdae9b0b33.png";